module.exports = __webpack_public_path__ + "img/G_icon.a2c07714.svg";